import { buildAetherBlocks } from '@/services/chatApi/aetherProjectBlocks'
import { friendlyProgressDetailText, friendlyProgressSummaryText } from './progressLabelVocabulary.js'

export function serverThreadToNav(thread) {
  return {
    id: thread.id,
    title: thread.title || 'New chat',
    status: thread.status,
    createdAt: thread.created_at ? Date.parse(thread.created_at) : undefined,
    updatedAt: thread.updated_at ? Date.parse(thread.updated_at) : undefined,
  }
}
export function serverMessageToClient(message) {
  const content = message?.content && typeof message.content === 'object' ? message.content : {}
  const text = message.text_content || content.text || content.message || content.reply || ''
  const projectBlocks = content.project ? buildAetherBlocks(text, new Map(), content.project) : null
  const blocks =
    projectBlocks || (Array.isArray(content.blocks) && content.blocks.length ? content.blocks : null)
  const meta = content.meta && typeof content.meta === 'object' ? content.meta : {}
  return {
    id: message.id,
    role: message.role,
    text,
    createdAt: message.created_at ? Date.parse(message.created_at) : Date.now(),
    ...(blocks ? { blocks } : {}),
    ...(content.thoughtSummary ? { thoughtSummary: friendlyProgressSummaryText(content.thoughtSummary) } : {}),
    ...(Array.isArray(content.thoughtDetails)
      ? { thoughtDetails: content.thoughtDetails.map(friendlyProgressDetailText).filter(Boolean) }
      : {}),
    ...(meta.agentName ? { agentName: meta.agentName } : {}),
    ...(meta.agentBrand ? { agentBrand: meta.agentBrand } : {}),
  }
}
